import { sendFunConfigInApp, sendFunConfigOutApp } from '../config/sendLog3Config';
// eslint-disable-next-line @typescript-eslint/no-var-requires
var qs = require('qs');
export var getTag = function (extraParams) {
    var tag = window.location.pathname
        .replace(/\.html$/, '')
        .split('/')
        .slice(1, 4)
        .join('_');
    if (extraParams) {
        var len = extraParams.length;
        for (var i = 0; i < len; i++) {
            if (extraParams[i].actually === tag) {
                return extraParams[i].expect;
            }
        }
    }
    return tag;
};
export var addUrlParam = function (args) {
    var urlParse = qs.parse(window.location.search.slice(1) || '');
    var data = {};
    if (!args)
        return data;
    // eslint-disable-next-line guard-for-in
    for (var key in args) {
        var name_1 = args[key].name;
        var val = void 0;
        if (Object.prototype.hasOwnProperty.call(urlParse, name_1)) {
            val = urlParse[name_1];
        }
        else if (Object.prototype.hasOwnProperty.call(args[key], 'defaultValue')) {
            val = args[key].defaultValue;
        }
        // eslint-disable-next-line no-undefined
        if (val !== undefined) {
            data[key] = val;
        }
    }
    return data;
};
export var addWindowParam = function (args) {
    var data = {};
    if (!args)
        return data;
    // eslint-disable-next-line guard-for-in
    for (var key in args) {
        var name_2 = args[key].name;
        var val = void 0;
        if (Object.prototype.hasOwnProperty.call(window, name_2)) {
            val = window[name_2];
        }
        else if (Object.prototype.hasOwnProperty.call(args[key], 'defaultValue')) {
            val = args[key].defaultValue;
        }
        // eslint-disable-next-line no-undefined
        if (val !== undefined) {
            data[key] = val;
        }
    }
    return data;
};
export var sendLog3 = function (env, event, params, extraSendFunc) {
    if (env.isInToutiaoProduct) {
        var funcConfig = {};
        var sendFlag = false;
        funcConfig = Object.assign(extraSendFunc || {}, sendFunConfigInApp);
        for (var key in funcConfig) {
            if (!sendFlag &&
                key !== 'sendUmengV3' &&
                funcConfig[key].canUse(env)) {
                sendFlag = true;
                funcConfig[key].func(env, event, params);
                break;
            }
        }
        if (!sendFlag) {
            funcConfig.sendUmengV3.func(env, event, params);
        }
    }
    else if (sendFunConfigOutApp.outApp.canUse(env)) {
        sendFunConfigOutApp.outApp.func(env, event, params);
    }
};
